import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { GetCampaignByIdNoTagsGQL } from 'generated/graphql';

/**
 * Handles configuration of the query builder module.
 * Type indicates which component type will be rendered
 *
 */
@Injectable({
  providedIn: 'root'
})
export class GetDefaultEntityTypeService {
  constructor(
    private getCampaignByIdNoTagsGQL: GetCampaignByIdNoTagsGQL,
  ) {
  }

  getDefaultEntityType(campaignId: string) {
    return this.getCampaignByIdNoTagsGQL.fetch({campaignId}).pipe(
      map(res => res.data.getCampaign.defaultEntityType),
    );
  }
}
